import { Record } from 'immutable';

export default class JobBoardRecord extends Record({
  name: undefined,
  type: undefined,
}) {
}
